import {CustomFieldNameModel} from "../models/edit/CustomFieldNameModel";
import angular from "angular";

export class EditCustomFields implements ng.IDirective {
    restrict= 'AEC';
    transclude = true;
    template = require('../../views/edit.customfieldnames.html').default;
    //public static $inject = ['$location', 'CustomFieldNameModel'];
    constructor(public $location:ng.ILocationService, public customFieldNameModel:CustomFieldNameModel) {
        var aoeu8787987987 = 3;
    }

    link = (scope:ng.IScope, element:ng.IAugmentedJQuery, attrs:ng.IAttributes, ctrl:any, transclude:ng.ITranscludeFunction) => {
        console.log(this.$location);
        console.log(this.customFieldNameModel);
        transclude((clone)=>{
            this.customFieldNameModel.connect().then(()=> {
                var tempPane = $(element).children().find('#cfnTempPane');
                var leftPane = $(element).children().find('#cfnLeftPane');
                var rightPane = $(element).children().find('#cfnRightPane');
                var divs:any = [];
                $.each(clone, (i, val)=> {
                    var pTag = angular.element(val);
                    divs.push(pTag);
                });
                console.log("divs count="+divs.length);
                divs = $.grep(divs, (val:any, i)=> {
                    var tempId = val != null && val.length > 0 ? val[0].id : null;
                    if (tempId == null)
                        return false;
                    var toDisplay:boolean = this.customFieldNameModel.getCustomFieldDisplay(tempId);
                    return toDisplay
                });
                divs.sort((a:any, b:any)=> {
                    var aId = a[0].id;
                    var bId = b[0].id;
                    var aIdIndex = this.customFieldNameModel.getCustomFieldDisplayIndex(aId);
                    var bIdIndex = this.customFieldNameModel.getCustomFieldDisplayIndex(bId);
                    console.log("aid="+aId+",aIdIndex="+aIdIndex+",bId="+bId+",bIdIndex="+bIdIndex);
                    return aIdIndex - bIdIndex;
                });
                var left:boolean = true;
                for (var i:number = 0; i < divs.length; i++) {
                    var pTag = divs[i];
                    if (i < divs.length / 2) {
                        var detachedDiv = pTag.detach();
                        $(detachedDiv).appendTo(leftPane);
                    }
                    else {
                        var detachedDiv = pTag.detach();
                        $(detachedDiv).appendTo(rightPane);
                    }
                    left = !left;
                }
            });
            var pigtag = 3;
        });
        var aoeuueoa = 3;

    }

    static factory():ng.IDirectiveFactory {
        var directive = ($location:ng.ILocationService, customFieldNameModel:CustomFieldNameModel) => {
            return new EditCustomFields($location, customFieldNameModel);
        }
        directive.$inject = ['$location', 'CustomFieldNameModel'];
        return directive;
    }
}
